import WorkflowBoard from "@/components/workflow/WorkflowBoard";
import OpsWorkflowNav from "@/components/workflow/OpsWorkflowNav";

export default function LeadWorkflow() {
  return (
    <div className="flex flex-col h-full">
      <OpsWorkflowNav />
      <div className="flex-1 min-h-0">
        <WorkflowBoard boardKey="lead" title="Lead Workflow" classicPath="/sales/pipeline" workspacePathFn={(id) => `/client-workspace/${id}`} />
      </div>
    </div>
  );
}
